<div class="filter" *ngIf="selectedItems.hierarchical.length > 0 || selectedItems.master.length > 0 
|| selectedItems.countries.length > 0 || selectedItems.sectors.length > 0 || selectedItems.ods.length > 0 
|| selectedItems.multiEvents.length > 0 || search != 'BY_RELEVANCE'">

  <span class="applied-filter">{{ 'FILTERS_SELECTED.APPLIED_FILTERS' | translate }} </span>
  <div class="delete-all" (click)="deleteAllFilters()">
    <img class="pointer" width="24" height="24" [alt]="'delete'" src="assets/img/delete_dark.svg">
    <span class="filter-line">{{ 'FILTERS_SELECTED.CLEAN_FILTERS' | translate }}</span>
  </div>
</div>

<div class="filter-group" *ngFor="let selectedHProp of getSelectedItems(hierarchicalProperties, selectedHProps, 'hierarchical'); index as i">
  <div class="filter-item" (click)="deleteSelectedItem(hierarchicalProperties, selectedHProps, 'hierarchical', selectedHProp.id, i)">
    <div class="filter-line">{{utilsService._api(selectedHProp.translations, 'name')}}</div>
    <img class="pointer" width="16" height="16" [alt]="'close'" src="assets/img/close_white.svg">
  </div>
</div>

<div class="filter-group" *ngFor="let selectedMProp of getSelectedItems(masterProperties, selectedMProps, 'master'); index as i">
  <div class="filter-item" (click)="deleteSelectedItem(masterProperties, selectedMProps, 'master', selectedMProp.id, i)">
    <div class="filter-line">{{utilsService._api(selectedMProp.translations, 'name')}}</div>
    <img class="pointer" width="16" height="16" [alt]="'close'" src="assets/img/close_white.svg">
  </div>
</div>

<div class="filter-group countries" *ngFor="let country of getSelectedItems(countries, selectedCountries, 'countries'); index as i">
  <div class="filter-item" (click)="deleteSelectedItem(countries, selectedCountries, 'countries', country.id, i)">
    <div class="filter-line">{{ utilsService._api(country.translations, 'translation') }}</div>
    <img class="pointer" width="16" height="16" [alt]="'close'" src="assets/img/close_white.svg">
  </div>
</div>

<div class="filter-group countries" *ngFor="let sector of getSelectedItems(sectors, selectedSectors, 'sectors'); index as i">
  <div class="filter-item" (click)="deleteSelectedItem(sectors, selectedSectors, 'sectors', sector.id, i)">
    <div class="filter-line">{{utilsService._api(sector.translations, 'name')}}</div>
    <img class="pointer" width="16" height="16" [alt]="'close'" src="assets/img/close_white.svg">
  </div>
</div>

<div class="filter-group countries" *ngFor="let ods of getSelectedItems(allOds, selectedHomeOds, 'ods'); index as i">
  <div class="filter-item" (click)="deleteSelectedItem(allOds, selectedHomeOds, 'ods', ods.id, i)">
    <div class="filter-line">{{utilsService._api(ods.translations, 'name')}}</div>
    <img class="pointer" width="16" height="16" [alt]="'close'" src="assets/img/close_white.svg">
  </div>
</div>

<div class="filter-group countries" *ngFor="let multiEvent of getSelectedItems(multiEvents, selectedMultiEvents, 'multiEvents'); index as i">
  <div class="filter-item" (click)="deleteSelectedItem(multiEvents, selectedMultiEvents, 'multiEvents', multiEvent.id, i)">
    <div class="filter-line">{{ multiEvent.label }}</div>
    <img class="pointer" width="16" height="16" [alt]="'close'" src="assets/img/close_white.svg">
  </div>
</div>

<div class="filter">
  <span class="applied-filter" title="{{ 'FILTERS_SELECTED.ORDER' | translate }}">{{ 'FILTERS_SELECTED.ORDER' | translate }}</span>
</div>
<div class="filter-group filter-group--inline">
  <div class="filter-item" [ngClass]="{ 'filter-item--unactive': !orderFilter.active }" (click)="activeOrderFilter(orderFilter)" *ngFor="let orderFilter of orderFilters">
    <div class="filter-line">{{ 'FILTERS_SELECTED.ORDER_FILTER_' + orderFilter.name.toUpperCase() | translate }}</div>
  </div>
</div>
